import React, { useMemo, useState } from 'react';
import { computeCbmFromDimensions } from '../utils/cbm';

const toPositiveNumber = (value) => {
  const n = Number.parseFloat(value);
  return Number.isFinite(n) && n > 0 ? n : 0;
};

const CbmCalculator = ({ title = 'CBM Calculator', compact = false }) => {
  const [unit, setUnit] = useState('cm');
  const [length, setLength] = useState('');
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const [quantity, setQuantity] = useState(1);

  const { cbmPerBox, totalCbm } = useMemo(() => {
    const l = toPositiveNumber(length);
    const w = toPositiveNumber(width);
    const h = toPositiveNumber(height);
    const qty = Number.parseInt(quantity, 10) || 0;

    if (!l || !w || !h || !qty) {
      return { cbmPerBox: 0, totalCbm: 0 };
    }

    const perBoxStr = computeCbmFromDimensions(unit, String(l), String(w), String(h));
    const perBox = Number.parseFloat(perBoxStr) || 0;
    return {
      cbmPerBox: perBox,
      totalCbm: perBox * qty
    };
  }, [length, width, height, quantity, unit]);

  const reset = () => {
    setUnit('cm');
    setLength('');
    setWidth('');
    setHeight('');
    setQuantity(1);
  };

  return (
    <div className={compact ? 'card' : 'admin-card'}>
      <h3 style={{ marginTop: 0, marginBottom: '0.75rem', fontSize: compact ? '1.1rem' : '1.2rem' }}>{title}</h3>
      <p className="jet-cbm-desc" style={{ marginTop: 0, marginBottom: '1rem', fontSize: '0.9rem' }}>
        Enter dimensions in cm, inch, or feet to calculate cubic meter volume.
      </p>

      <div className={compact ? 'grid grid-2' : 'grid grid-3'} style={{ gap: '0.75rem', marginBottom: '0.75rem' }}>
        <div>
          <label className="form-label">Unit</label>
          <select className="form-input" value={unit} onChange={(e) => setUnit(e.target.value)}>
            <option value="cm">cm</option>
            <option value="inch">inch</option>
            <option value="feet">feet</option>
          </select>
        </div>
        <div>
          <label className="form-label">Length ({unit})</label>
          <input className="form-input" type="number" min="0" step="any" value={length} onChange={(e) => setLength(e.target.value)} />
        </div>
        <div>
          <label className="form-label">Width ({unit})</label>
          <input className="form-input" type="number" min="0" step="any" value={width} onChange={(e) => setWidth(e.target.value)} />
        </div>
      </div>

      <div className={compact ? 'grid grid-2' : 'grid grid-3'} style={{ gap: '0.75rem' }}>
        <div>
          <label className="form-label">Height ({unit})</label>
          <input className="form-input" type="number" min="0" step="any" value={height} onChange={(e) => setHeight(e.target.value)} />
        </div>
        <div>
          <label className="form-label">Quantity</label>
          <input className="form-input" type="number" min="1" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
          <button className="btn btn-secondary" type="button" onClick={reset}>
            Reset
          </button>
        </div>
      </div>

      <div className="jet-surface-muted jet-cbm-result" style={{ marginTop: '1rem' }}>
        <div style={{ fontSize: '0.95rem', marginBottom: '0.3rem' }}>
          <strong>CBM per box:</strong> {cbmPerBox.toFixed(2)} m3
        </div>
        <div style={{ fontSize: '0.95rem' }}>
          <strong>Total CBM:</strong> {totalCbm.toFixed(2)} m3
        </div>
      </div>
    </div>
  );
};

export default CbmCalculator;
